module.exports = __webpack_public_path__ + "static/img/3.46444001.png";